import { ZCDCheckbox, ZCDCheckboxVariant } from '@zencity/common-ui';
import React, { ReactElement, useEffect, useState } from 'react';
import { ReportBuilderFilterProps } from 'screens/WidgetGenerator/reportGeneratorComponents/constants';

interface Props {
  reportBuilderProps: ReportBuilderFilterProps;
  filterLabel: string;
  defaultValue: boolean;
}

export const BooleanFilter = (props: Props): ReactElement => {
  const { filterLabel, reportBuilderProps, defaultValue } = props;
  const { value: filterValue, onChange } = reportBuilderProps;
  const isCheckedFilterValue = filterValue as boolean;

  const isChecked = isCheckedFilterValue ?? defaultValue;
  useEffect(() => {
    onChange(isChecked);
    // Avoid re-rendering when the filter value changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isChecked, isCheckedFilterValue]);

  const [checked, setChecked] = useState(isChecked);
  const handleOnToggle = (value: boolean) => {
    setChecked(value);
    onChange(value);
  };
  return (
    <ZCDCheckbox variant={ZCDCheckboxVariant.TOGGLE} checked={checked} label={filterLabel} onChange={handleOnToggle} />
  );
};
